export default {
  dreRevenueIncrementMetrics: (state) => state.dreRevenueIncrementMetrics,
  dreOffersCouponsMetrics: (state) => state.dreOffersCouponsMetrics,
  dreProductsMetrics: (state) => state.dreProductsMetrics,
  dreClientsDistributionBefore: (state) => state.dreClientsDistributionBefore,
  dreChannelsDistribution: (state) => state.dreChannelsDistribution,
  dreAnalysedPeriod: (state) => state.dreAnalysedPeriod,
  hasDreOffersSchedulesResults: (state) => state.hasDreOffersSchedulesResults,
  dreAnalyticConfigurations: (state) => state.dreAnalyticConfigurations,
}
